export const LOAN_FULL_OR_BASIC_LOAD = 'LOAN_FULL_OR_BASIC_LOAD'
export const LOAN_FULL_OR_BASIC_LOAD_PENDING = 'LOAN_FULL_OR_BASIC_LOAD_PENDING'
export const LOAN_FULL_OR_BASIC_LOAD_FULFILLED = 'LOAN_FULL_OR_BASIC_LOAD_FULFILLED'
export const LOAN_FULL_OR_BASIC_LOAD_REJECTED = 'LOAN_FULL_OR_BASIC_LOAD_REJECTED'

export const LOAN_FULL_OR_BASIC_LOAD_UPDATE = 'LOAN_FULL_OR_BASIC_LOAD_UPDATE'
export const LOAN_FULL_OR_BASIC_LOAD_UPDATE_PENDING = 'LOAN_FULL_OR_BASIC_LOAD_UPDATE_PENDING'
export const LOAN_FULL_OR_BASIC_LOAD_UPDATE_FULFILLED = 'LOAN_FULL_OR_BASIC_LOAD_UPDATE_FULFILLED'
export const LOAN_FULL_OR_BASIC_LOAD_UPDATE_REJECTED = 'LOAN_FULL_OR_BASIC_LOAD_UPDATE_REJECTED'
